import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AccordionRow } from '@guardian/source/react-components';
import { useEffect, useRef, useState } from 'react';
import { sendTrackingEventsOnClick } from 'helpers/productPrice/subscriptions';
export function TabAccordionRow({ trackingId, label, children, }) {
    const initialRender = useRef(true);
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        // don't call sendTrackingEventsOnClick on initialRender
        if (initialRender.current) {
            initialRender.current = false;
        }
        else {
            sendTrackingEventsOnClick({
                id: `${trackingId}-${expanded ? 'expand' : 'minimize'}`,
                product: 'Paper',
                componentType: 'ACQUISITIONS_BUTTON',
            })();
        }
    }, [expanded]);
    return (_jsx(AccordionRow, { label: label, onClick: () => {
            setExpanded(!expanded);
        }, children: children }));
}
